import React, { useEffect,  useState } from 'react';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import FieldFormsDetailsDisplay from './FieldFormsDetailsDisplay';
import FieldFormsArtifactsDisplay from './FieldFormsArtifactsDisplay';
import { downloadTestFieldForm } from 'utils/ProjectConfigurationUtil'

const tabs = [
  new Tab({ label: "Edit", value: "Details" }),
  new Tab({ label: "Artifacts", value: "Artifacts" })
]

const FieldFormsDetails = ({ checklistItem,callback }) => {
  const [activeTab, setActiveTab] = useState('Details');
  const [details, setDetails] = useState(checklistItem);

  useEffect(() => {
    async function anyNameFunction() {
      const download =  await downloadTestFieldForm(details.FormId)
      checklistItem.URL = download.url;
      setDetails(checklistItem)
      
    }

    anyNameFunction();
},[details])

  return (
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >
      {activeTab === "Details" ? <FieldFormsDetailsDisplay key={1} defaultValues={details} loaded={!!details} CRUDType={"UPDATE"} callback={callback}/> : <FieldFormsArtifactsDisplay artifact={details} />}
    </TabbedPage>
  )
}

export default FieldFormsDetails;